import React from "react"

export const DeleteIcon = ({ fill, className }) =>
<svg 
  xmlns="http://www.w3.org/2000/svg"
  className={className}
  fill={fill}
  stroke='currentColor'
  strokeWidth='0'
  strokeLinecap='round'
  strokeLinejoin='round'
  width="24" height="24"
  x="0px" y="0px"
  viewBox="0 0 64 64">
<g>
	<path d="M48.9,8.8h-7.7V7.1c0-3-2.4-5.4-5.4-5.4h-7.7c-3,0-5.4,2.4-5.4,5.4v1.7h-7.7c-2.9,0-5.3,2.4-5.3,5.3v3c0,2.2,1.3,4,3.2,4.8
		l1.6,34.6c0.2,3.3,2.8,5.8,6.1,5.8h22.5c3.3,0,6-2.6,6.1-5.8L51,21.8c1.9-0.8,3.2-2.7,3.2-4.8v-3C54.2,11.2,51.8,8.8,48.9,8.8z
		 M27.3,7.1c0-0.5,0.4-0.9,0.9-0.9h7.7c0.5,0,0.9,0.4,0.9,0.9v1.7h-9.4V7.1z M14.3,14.1c0-0.4,0.3-0.8,0.8-0.8h33.8
		c0.4,0,0.8,0.3,0.8,0.8v3c0,0.4-0.3,0.8-0.8,0.8H15.1c-0.4,0-0.8-0.3-0.8-0.8V14.1z M43.2,57.8H20.8c-0.9,0-1.6-0.7-1.6-1.5
		l-1.6-33.9h28.9l-1.6,33.9C44.8,57.1,44.1,57.8,43.2,57.8z"/>
	<path d="M32,32.4c-1.2,0-2.3,1-2.3,2.3v12.7c0,1.2,1,2.3,2.3,2.3c1.2,0,2.3-1,2.3-2.3V34.7C34.3,33.4,33.2,32.4,32,32.4z"/>
	<path d="M40,34.4c-1.3-0.1-2.3,0.8-2.4,2.1l-0.6,8.8c-0.1,1.2,0.8,2.3,2.1,2.4c0.1,0,0.1,0,0.2,0c1.2,0,2.2-0.9,2.2-2.1l0.6-8.8
		C42.1,35.5,41.2,34.5,40,34.4z"/>
	<path d="M23.9,34.4c-1.2,0.1-2.2,1.2-2.1,2.4l0.7,8.8c0.1,1.2,1.1,2.1,2.2,2.1c0.1,0,0.1,0,0.2,0c1.2-0.1,2.2-1.2,2.1-2.4l-0.7-8.8
		C26.3,35.2,25.2,34.3,23.9,34.4z"/>
</g>
</svg>

